// A tool call that ended by the PERSON's choice — they cancelled the app's card — rather than by failing.
// The host reads `_meta["com.resatech.talkie/outcome"]` on an `isError` result (dobby-agentic-app-bridge
// `convert.rs`) and says "Cancelled in {app}" instead of reporting a failure (mount-on-demand FR-11).
// Pure — the browser bundles import it.

export const OUTCOME_META_KEY = "com.resatech.talkie/outcome";

/**
 * The person cancelled: an OUTCOME, returned, not thrown — `AppBridge` turns a throw into a plain
 * `isError` result with no outcome. No `structuredContent`: there is no result, and an error result is exempt from
 * the output schema. The host's own cancellation (expired) and a superseded card stay ordinary errors.
 */
export function cancelledByThePerson(message) {
  return { isError: true, content: [{ type: "text", text: message }], _meta: { [OUTCOME_META_KEY]: "cancelled" } };
}
